// src/utils/tiktokPixel.ts
declare global {
  interface Window {
    ttq?: any;
  }
}

let loaded = false;

export function loadTikTokPixel(pixelId: string) {
  if (typeof window === 'undefined') return;
  if (!pixelId) return;

  if (window.ttq && loaded) return;

  (function (w: any, d: any, t: any) {
    w.TiktokAnalyticsObject = t;
    const ttq = (w[t] = w[t] || []);
    ttq.methods = [
      'page',
      'track',
      'identify',
      'instances',
      'debug',
      'on',
      'off',
      'once',
      'ready',
      'alias',
      'group',
      'enableCookie',
      'disableCookie',
      'holdConsent',
      'revokeConsent',
      'grantConsent'
    ];

    ttq.setAndDefer = function (t: any, e: any) {
      t[e] = function () {
        t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };

    for (let i = 0; i < ttq.methods.length; i++) {
      ttq.setAndDefer(ttq, ttq.methods[i]);
    }

    ttq.load = function (e: string) {
      const url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = `${url}?sdkid=${e}&lib=${t}`;
      const x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    };

    ttq.load(pixelId);
    ttq.page();
  })(window, document, 'ttq');

  loaded = true;
}

/* ---------------- EVENTS ---------------- */

export function trackViewContent(args: { contentName: string }) {
  window.ttq?.track('ViewContent', {
    content_name: args.contentName,
    content_type: 'product'
  });
}

export function trackInitiateCheckout(args: {
  contentId: string;
  contentName: string;
  value: number;
  currency?: string;
}) {
  const currency = args.currency ?? 'AUD';

  window.ttq?.track('InitiateCheckout', {
    content_id: args.contentId,
    content_name: args.contentName,
    content_type: 'product',
    value: args.value,
    currency
  });
}

export function trackPurchase(args: {
  value: number;
  currency?: string;
  contentId: string;
  contentName: string;
  upsellPurchased: boolean;
  quantity?: number;
}) {
  const currency = args.currency ?? 'AUD';

  window.ttq?.track('CompletePayment', {
    content_id: args.contentId,
    content_name: args.contentName,
    content_type: 'product',
    value: args.value,
    currency,
    quantity: args.quantity ?? 1,

    // custom param (TikTok accepts this fine)
    upsellPurchased: args.upsellPurchased
  });
}
